import { NgModule } from "@angular/core";
import { SearchRepository } from "src/app/domain/repositories/search/search.repository";
import { SearchImplementationRepository } from "./repositories/search/search-implementation.repository";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { SearchEnrollmentUseCase } from "src/app/domain/usecases/search/search-enrollment.usecase";
import { UpdatePersonUseCase } from "../domain/usecases/update-person/update-person-enrollment.usecase";
import { UpdatePersonRepository } from "../domain/repositories/update-person/update-person.repository";
import { UpdatePersonImplementationRepository } from "./repositories/update-person/update-person-implementation.repository";

const searchEnrollmentUseCaseFactory =
  (searchRepository: SearchRepository) => new SearchEnrollmentUseCase(searchRepository);

const updatePersonUseCaseFactory =
  (updatePersonRepository: UpdatePersonRepository) => new UpdatePersonUseCase(updatePersonRepository);

export const searchEnrollmentUseCaseProvider = {
  provide: SearchEnrollmentUseCase,
  useFactory: searchEnrollmentUseCaseFactory,
  deps: [SearchRepository],
};

export const updatePersonUseCaseProvider = {
  provide: UpdatePersonUseCase,
  useFactory: updatePersonUseCaseFactory,
  deps: [UpdatePersonRepository],
};


@NgModule({
  providers: [
    searchEnrollmentUseCaseProvider,
    { provide: SearchRepository, useClass: SearchImplementationRepository },
    updatePersonUseCaseProvider,
    { provide: UpdatePersonRepository, useClass: UpdatePersonImplementationRepository },
  ],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
})
export class DataModule { }